import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=36cdf020&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=36cdf020&prod&lang=less&scoped=true"
import style1 from "./detail.vue?vue&type=style&index=1&id=36cdf020&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cdf020",
  null
  
)

export default component.exports